import React from 'react';
import { ArrowRight, CheckCircle, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = ({ onContactClick }) => {
  return (
    <section id="hero" className="relative pt-32 pb-20 bg-gradient-to-br from-[#EFEBE9] via-white to-[#EFEBE9] overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-[#D7CCC8]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-[#8D6E63]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-[#D7CCC8]">
              <Shield className="w-4 h-4 text-[#3E2723]" />
              <span className="text-sm font-medium text-[#3E2723]">USPTO Filing Experts Since 2008</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#3E2723] leading-tight">
              Protect Your Brand with Professional <span className="text-[#8D6E63]">Trademark Registration</span>
            </h1>
            
            <p className="text-xl text-[#8D6E63] leading-relaxed">
              Secure your brand identity with comprehensive trademark registration services. Expert guidance through every step of the USPTO filing process.
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <CheckCircle className="w-6 h-6 text-[#3E2723] flex-shrink-0" />
                <span className="text-[#3E2723] text-lg">Fast & Efficient USPTO Filing</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-6 h-6 text-[#3E2723] flex-shrink-0" />
                <span className="text-[#3E2723] text-lg">95% Success Rate on Registrations</span>
              </div>
              <div className="flex items-center gap-3">
                <CheckCircle className="w-6 h-6 text-[#3E2723] flex-shrink-0" />
                <span className="text-[#3E2723] text-lg">Dedicated Case Manager Support</span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={onContactClick}
                className="bg-[#3E2723] hover:bg-[#5D4037] text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:shadow-xl"
              >
                Register My Trademark
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button
                onClick={onContactClick}
                variant="outline"
                className="border-2 border-[#3E2723] text-[#3E2723] hover:bg-[#3E2723] hover:text-white px-8 py-6 text-lg font-semibold transition-all duration-300"
              >
                Get Free Consultation
              </Button>
            </div>
            
            <div className="flex items-center gap-8 pt-4">
              <div>
                <div className="text-3xl font-bold text-[#3E2723]">1000+</div>
                <div className="text-sm text-[#8D6E63]">Trademarks Filed</div>
              </div>
              <div className="w-px h-12 bg-[#D7CCC8]"></div>
              <div>
                <div className="text-3xl font-bold text-[#3E2723]">95%</div>
                <div className="text-sm text-[#8D6E63]">Success Rate</div>
              </div>
              <div className="w-px h-12 bg-[#D7CCC8]"></div>
              <div>
                <div className="text-3xl font-bold text-[#3E2723]">15+</div>
                <div className="text-sm text-[#8D6E63]">Years Experience</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative z-10 bg-white p-8 rounded-2xl shadow-2xl border-4 border-[#D7CCC8]">
              <img
                src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&auto=format&fit=crop"
                alt="Trademark Registration Services"
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#3E2723] text-white p-6 rounded-lg shadow-xl">
                <div className="text-sm font-medium mb-1">Starting at</div>
                <div className="text-4xl font-bold">$45</div>
                <div className="text-xs mt-1">+ Filing Fee</div>
              </div>
            </div>
            <div className="absolute -top-4 -left-4 w-full h-full bg-[#8D6E63]/20 rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
